module.exports = __webpack_public_path__ + "526c5d28f2134b60d14d5e216c8a62d6.svg";